import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
//import { alertDialogChanged } from '../Actions/alertDialogActions';
import { alertDialogChanged } from '../../features/alertDialog/alertDialogSlice'

export default function AlertDialog() {
    const dispatch = useDispatch()
    const alertDialog = useSelector((state) => state.alertDialogReducer)

    function closeAlertDialog() {
        //setAlertDialog({title: "", message: ""});
        dispatch(alertDialogChanged({ title: '', message: '' }))
    }

    return (
        <>
            {alertDialog.message.length > 0 && (
                <Dialog title={alertDialog.title} onClose={closeAlertDialog}>
                    <div style={{ fontSize: '1.5rem' }}>Alert:</div>
                    <div style={{ fontSize: '14px' }}>
                        <br />
                        {alertDialog.message}
                    </div>
                    <DialogActionsBar layout={'stretched'}>
                        <button type="button" className="k-button" onClick={closeAlertDialog}>
                            OK
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}
        </>
    )
}
